export default {"src":"/_next/static/media/Arrow.6b3aaf71.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};